$(".hero-slider").slick({
    slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: 'ondemand',
        arrows:false,
        dots:true,
        autoplay: true,
    pauseOnHover:false,
    autoplaySpeed: 4000,
        adaptiveHeight: true,
        responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
$(".product-card-slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: 'ondemand',
        arrows:true,
        dots:false,
        autoplay: false,
        responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows:false
      }
    }
  ]
});
jQuery(".media-coverage-carousel").slick({
        speed: 3000,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: 'linear',
        centerMode: true,
        draggable: false,
        pauseOnHover: false,
        pauseOnFocus: false,
    slidesToShow: 7,
        slidesToScroll: 1,
        arrows:false,
        adaptiveHeight: true,
        responsive: [
    {
      breakpoint: 950,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 660,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
  });
$(".home-categories").slick({
    dots: true,
    slidesToShow: 4,
		slidesToScroll: 1,
		arrows:true,
        
		draggable:true,
		dots:false,
		adaptiveHeight: true,
		responsive: [
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows:false
      }
    },
    {
      breakpoint: 760,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows:false
      }
    }
  ]
  });
$(".party-carousel").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: 'ondemand',
        arrows:true,
        dots:true,
        autoplay: false
});

//Home Reviews slider for mobile
if (window.innerWidth < 768) {
  $('.home-reviews-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyLoad: 'ondemand',
    arrows: true,
    dots: true,
    autoplay: false
  });
}